import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconDirectionsRailway = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconDirectionsRailway",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M208-80q-14 0-19-12t5-22l46-46h480l46 46q10 10 5 22t-19 12zm72-120 40-40h-20q-58 0-99-41t-41-99v-260q0-129 93-204t227-76 228 76 92 204v260q0 58-41 99t-99 41h-20l40 40zm200-160q25 0 43-17t17-43-17-42-43-18-42 18-18 42 18 43 42 17M240-600h480v-40q0-23-4-42t-13-38H257q-8 18-12 38t-5 42z"
  })
}));